import request from '@/utils/request'

export function getSendNoticeType() {
  return request({
    url: 'api/v1/sendNotice/getTypeCfg',
    method: 'get'
  })
}

export function testSendNotice(data) {
  return request({
    url: 'api/v1/sendNotice/testSendNotice',
    method: 'post',
    data: data
  })
}

export function updateCfg(data) {
  return request({
    url: 'api/v1/sendNotice/updateCfg',
    method: 'post',
    data: data
  })
}

export function getCfg(data) {
  return request({
    url: 'api/v1/sendNotice/getCfg',
    method: 'post',
    params: data
  })
}

export function delCfg(data) {
  return request({
    url: 'api/v1/sendNotice/delete',
    method: 'delete',
    data: data
  })
}

